module.exports = __webpack_public_path__ + "stylesheets/user-notification_bb8f6faa5a335ac0b9d577bd79c70b48.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/notification/user-notification.less
// module id = vkeZ
// module chunks = 153